export const PREFERRED_TIMEZONES = [
    "Europe/Brussels",
    "Europe/Paris",
    "Europe/London",
    "Europe/Berlin",
    "Europe/Warsaw",
    "Asia/Tokyo",
    "US/Central"
];

